// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { fetchSiteByASR } from 'helpers/api'

import {
  INVALID_INPUT,
  UNCAUGHT_ERROR,
} from 'errors'

import {
  getNestedByString,
  setNestedValueInObject,
} from 'helpers/reduxFormFunctions'

export const asrValidate = async (formValues, f, props, pathString) => {
  const {
    asyncErrors = {},
  } = props

  const hasAsyncErrors = Object.keys(asyncErrors).length
  const v = getNestedByString(formValues, pathString)

  // if the input has no value and the asyncErrors object has no properties,
  // the user blurred over the input field. Do not reject this.
  if (!hasAsyncErrors && !v.length) {
    return
  } else if (!v.length) {
    // even if there's no value, throw the asyncErrors object since
    // there may already be other async errors that we want to keep
    throw asyncErrors
  } else if (v.match(/^\d+$/) === null) {
    // ensure the value is only numeric
    setNestedValueInObject(asyncErrors, pathString, INVALID_INPUT)
    throw asyncErrors
  } else if (v.length !== 7) {
    // ASR must be 7 chars long
    setNestedValueInObject(asyncErrors, pathString, 'ASR must be 7 numbers long.')
    throw asyncErrors
  }

  try {
    // we just need to make sure that the ASR is good. We don't need to update anything in the form.
    const { entity } = await fetchSiteByASR(v)
    const { statusCode } = entity

    // Only status codes of C and G are allowed for ASRs at this step.
    if (statusCode !== 'C' && statusCode !== 'G') {
      throw new Error(`ASR ${v} not found.`)
    }
  } catch (err) {
    console.warn(err)
    const errorMessage = err.message || UNCAUGHT_ERROR
    setNestedValueInObject(asyncErrors, pathString, errorMessage)
    throw asyncErrors
  }

  // even though everything went smoothly, we need to persist
  // any other async errors which are present
  if (hasAsyncErrors) {
    throw asyncErrors
  }
}
